import React, { useRef, useState } from "react";
import { FaPlay, FaPause } from "react-icons/fa";

const InfluencerSection = () => {
  const influList = [
    {
      name: "video3",
      src: "https://d1lfl311x81a6w.cloudfront.net/Static_images/video3.mp4",
      link: "https://www.instagram.com/reel/DJ0v59XzGSZ/?igsh=MWlnMDNiano5NHh6eg==",
      thumbnail: "video-3.webp",
      banner: "JERRY200",
    },
    {
      name: "video4",
      src: "https://d1lfl311x81a6w.cloudfront.net/Static_images/video4.mp4",
      link: "https://www.instagram.com/reel/DHn1RxLi6I-/?igsh=MWhnaWJ2ZW11eDltZw==",
      thumbnail: "video-4.webp",
      banner: "25% OFF ON SETS",
    },
    {
      name: "video1",
      src: "https://d1lfl311x81a6w.cloudfront.net/Static_images/video1.mp4",
      link: "https://www.instagram.com/reel/DFUvBQ8o0je/?igsh=dDB4ZXZsdzBybXBq",
      thumbnail: "video-1.webp",
      banner: "25% OFF ON RINGS",
    },
    {
      name: "video2",
      src: "https://d1lfl311x81a6w.cloudfront.net/Static_images/video2.mp4",
      link: "https://www.instagram.com/reel/DEfGLySJa9n/?igsh=MTl5empmNWtzd253cQ==",
      thumbnail: "video-2.webp",
      banner: "25% OFF ON EARRINGS",
    },
  ];

  const videoRefs = useRef([]);
  const [isPlaying, setIsPlaying] = useState(Array(influList.length).fill(false));

  const handlePlayPause = (e, index) => {
    e.stopPropagation();

    const updatedStates = isPlaying.map((_, i) => {
      const video = videoRefs.current[i];
      if (!video) return false;

      if (i === index) {
        if (video.paused) {
          video.play();
          return true;
        } else {
          video.pause();
          return false;
        }
      } else {
        video.pause();
        return false;
      }
    });

    setIsPlaying(updatedStates);
  };

  return (
    <div className="relative bg-gradient-to-r from-[#F3F3FD] to-white mx-auto bg-cover bg-no-repeat">
      {/* Decorative Images with Fixed Size */}
      <img
        src="/top-right.webp"
        width={160}
        height={160}
        alt="Top decoration"
        className="absolute top-0 right-0 w-[80px] md:w-[160px] h-auto"
        loading="lazy"
      />
      <img
        src="/bottom-left.webp"
        width={100}
        height={100}
        alt="Bottom decoration"
        className="absolute bottom-0 left-0 w-[100px] h-auto"
        loading="lazy"
      />

      {/* Header */}
      <div className="flex flex-col items-center gap-1 py-8 px-4">
        <p className="text-center text-base font-semibold uppercase">INFLUENCER CORNER</p>
        <p className="text-center text-2xl md:text-3xl font-semibold text-[#C71C8E]">Discover their Story</p>
        <p className="text-center text-sm font-semibold">
          with <span className="text-[18px] text-[#000080]">SAIRAH</span>
        </p>
      </div>

      {/* Videos Grid */}
      <div className="mx-auto max-w-7xl px-4 sm:px-8 md:px-12 lg:px-20 pb-10">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {influList.map((item, index) => (
            <div key={item.name} className="w-full">
              <div
                className="bg-white rounded-lg overflow-hidden relative cursor-pointer border-4 border-[#9797E9] shadow-md aspect-[9/16]"
                onClick={() => window.open(item.link, "_blank")}
              >
                {/* Video Wrapper with Fixed Aspect Ratio */}
                <div className="relative w-full h-full">
                  <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    src={item.src}
                    poster={item.thumbnail}
                    className="absolute inset-0 w-full h-full object-cover"
                    preload="metadata"
                    width={300}
                    height={533} // 9:16 ratio to prevent layout shift
                    onEnded={() => {
                      videoRefs.current[index]?.load();
                      const updated = [...isPlaying];
                      updated[index] = false;
                      setIsPlaying(updated);
                    }}
                  />
                </div>

                {/* Play/Pause Button */}
                <button
                  className="absolute bottom-3 right-2 z-10 bg-[#22229399] text-white p-3 rounded-full"
                  onClick={(e) => handlePlayPause(e, index)}
                  aria-label={isPlaying[index] ? "Pause video" : "Play video"}
                >
                  {isPlaying[index] ? (
                    <FaPause className="text-[8px] md:text-[16px]" />
                  ) : (
                    <FaPlay className="text-[8px] md:text-[16px]" />
                  )}
                </button>

                {/* Banner */}
                <div className="absolute top-3 left-2 z-10">
                  <div className="flex items-center px-2 py-2 rounded-md bg-[#222293]/80 text-white">
                    {index === 0 ? (
                      <>
                        <p className="text-[9px] md:text-[12px] font-bold">CODE</p>
                        <div className="ml-2 bg-white rounded-md">
                          <p className="px-2 py-1 text-[9px] md:text-[12px] font-[600] text-[#C71C8E]">
                            {item.banner}
                          </p>
                        </div>
                      </>
                    ) : (
                      <p className="text-[9px] md:text-[12px] md:text-base font-[600]">{item.banner}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfluencerSection;